<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>


        <div class="row mt-5">
            <div class="col-12 ml-2 mr-2">

                <div class="KSpinner" v-if="isLoading">                    
                    <div class="spinner-border text-info"></div>
                    <h2 class="LoadingText">Loading....</h2>
                </div>
                
                    <div class=".continer" v-else>
                        <div class="d-flex justify-content-justify-content-lg-start">
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button type="button" class="btn btn-info ibutton"  @click="filter('All')" :disabled="filterCriteria == 'All'" style="padding-left:20px;padding-right:20px">All</button>
                                <button type="button" class="btn btn-success ibutton" @click="filter('Approved')" :disabled="filterCriteria == 'Approved'">Approved</button>
                                <button type="button" class="btn btn-danger ibutton" @click="filter('Rejected')" :disabled="filterCriteria == 'Rejected'">Rejected</button>
                            </div>
                        </div>

                        <div class="iHScrollable">     
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search by First Name or Surname" single-line hide-details></v-text-field>
                            <v-data-table :headers="headers" :items="data" class="elevation-1" :search="search" :custom-filter="customFilter">

                            <template v-slot:top>
                                <v-toolbar flat >
                                    <v-col cols="3"></v-col>
                                    <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title class="iscreentitle">{{ getTitile }}</v-toolbar-title>  </v-col>
                                    <v-col cols="3"></v-col>                                    
                                </v-toolbar>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="viewItem(item.id)" data-toggle="tooltip" data-placement="top" title="View"><font-awesome-icon icon="eye" size="sm"/></button>
                                <!-- <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="editItem(item.id)" data-toggle="tooltip" data-placement="top" title="Edit"><font-awesome-icon icon="edit" size="sm"/></button> -->
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="generateCV(item.id)" data-toggle="tooltip" data-placement="top" title="Generate Full CV" ><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="deleteItem(item.id)" data-toggle="tooltip" data-placement="top" title="Delete" v-if="isUserLoggedIn && isUserAdmin"><font-awesome-icon icon="trash" size="sm"/></button>
                                <button  class="btn btn-success m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="approve(item)" data-toggle="tooltip" data-placement="top" title="Approve" v-if="item.status != 'Approved'"><font-awesome-icon icon="check" size="sm"/></button>
                                <button  class="btn btn-warning m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="reject(item)" data-toggle="tooltip" data-placement="top" title="Reject" v-if="item.status != 'Rejected'"><font-awesome-icon icon="times" size="sm"/></button>
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                               {{ formatDateTime(item.createdAt) }}
                            </template>
                            <template v-slot:item.modifiedAt="{ item }">
                               {{ formatDateTime(item.modifiedAt) }}
                            </template>
                            <template v-slot:item.client="{ item }">
                               {{ getClientName(item.client) }}
                            </template>

                            <template v-slot:item.status="{ item }">
                                <v-chip :color="getColor(item.status)" dark>
                                    {{ item.status }}
                                </v-chip>
                            </template>

                            </v-data-table>
                            
                        </div>
                    </div>

                    <v-snackbar v-model="showSnackbar" >
                        {{ snackBarText }}
                        <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
                    </v-snackbar>

            </div>
        
        </div>    
        <Footer class="footerStickedToBottom" ></Footer>        

    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import {DB} from '../firebase/db';
import Utils from '../utils/util';
import Firebase from 'firebase/app'

export default {   
    name: 'PendingSeafarerList',  
    data() {
        return {
            dialog:false,
            data:[],

            currentPage: 1,
            perPage: 30,
            headers: [
                { text: 'Other Name', align: 'start', sortable: true, value: 'otherName',},                    
                { text: 'Surname', align: 'start', sortable: true, value: 'surname',},          
                { text: 'Rank Applied For', align: 'start', sortable: true, value: 'rankAppliedFor',},          
                // { text: 'Vessel Category', align: 'start', sortable: true, value: 'vesselCategory',},          
                // { text: 'DOB', align: 'start', sortable: true, value: 'dob',},          
                { text: 'Application Status', align: 'start', sortable: true, value: 'status',},          
                // { text: 'Reference Number', align: 'start', sortable: true, value: 'referenceNumber',},          
                // { text: 'Telephone', align: 'start', sortable: true, value: 'paTel',},          
                // { text: 'Email', align: 'start', sortable: true, value: 'email',},          
                         
                // { text: 'Created By', align: 'start', sortable: true, value: 'createdBy',},          
                // { text: 'Created At', align: 'start', sortable: true, value: 'createdAt',},          
                // { text: 'Modified By', align: 'start', sortable: true, value: 'modifiedBy',},          
                // { text: 'Modified At', align: 'start', sortable: true, value: 'modifiedAt',},          
                { text: 'Actions', align: 'start', sortable: false, value: 'actions',},          
            ],
            
            isInitiating:false,
            isLoading:false,
            showSnackbar:false,
            snackBarText:'',
            snackbarColor:'green',
            
            propTitle:'',
            filterCriteria:'All',

            search:'',
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    props:{
        propData:null,
    },
    created() {
        if(this.$route.params == undefined || this.$route.params.propData == undefined){
            this.fetchAll();
        }else{
            this.data = this.$route.params.propData;
            this.propTitle = this.$route.params.propTitle;
        }
        
    },
    methods: {  
        filter(filterCriteria){
            this.filterCriteria = filterCriteria;
            if(filterCriteria == 'All'){
                this.fetchAll();
            }else{
                this.fetch(filterCriteria);
            }
        },
        customFilter(value, query, item){
            return item.otherName != null && item.surname != null && (item.otherName.indexOf(query) !== -1 || item.surname.indexOf(query) != -1);
        },
        async fetchAll(){

            this.isLoading = true;
            const _this = this;
            this.data = [];

            DB.collection("seafarers_pending").
                orderBy("modifiedAt", "desc").
                get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { 
                        _this.data.push(doc.data());
                    });
                    _this.isLoading = false;
                })
                .catch((error) => {
                    _this.showError("Failed to fetch records. Error: ", error)
                    _this.data = [];
                    _this.isLoading = false;
                });
        },
        async fetch(filterCriteria){

            this.isLoading = true;
            const _this = this;
            this.data = [];

            DB.collection("seafarers_pending").
                where("status", "==", filterCriteria).
                get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { 
                        _this.data.push(doc.data());
                    });
                    _this.isLoading = false;
                })
                .catch((error) => {
                    _this.showError("Failed to fetch records. Error: ", error)
                    _this.data = [];
                    _this.isLoading = false;
                });
        },
        viewItem(id){
            var route = '/view-online-cv?id=' + id  + '&mode=view'          
            this.$router.push(route);
        },
        async deleteItem(id){
            const _this = this;
            if(confirm('Do you really want to delete the record?')){

                var batch = DB.batch();
                let ref = DB.collection('seafarers_pending').doc(id);
                batch.delete(ref)
                
                batch.commit().then(() => {
                    _this.showMsg("CV Application Deleted successfully!");
                    _this.fetchAll();
                }).catch((error) => {  
                    _this.showError("Failed to delete CV Application. Error: ", error.message);
                    _this.fetchAll();
                });
            }
        },
        reject(item){
            
            const _this = this;
            if(confirm('Do you want to reject the application?')){
                item.status = 'Rejected';
                item.modifiedBy = Utils.getUser();
                item.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();

                DB.collection('seafarers_pending').doc(item.id).update(item).then(() => {
                    _this.showMsg("Application rejected successfully!");
                    _this.fetchAll();
                }).catch((error) => {
                    _this.showError("Failed to reject Application. Error: ", error.message)
                });
            }
        },
        async approve(item){
            const _this = this;
            if(confirm('Do you want to approve the application (This will create a seafarer in the system)?')){                

                var batch = DB.batch();

                item.status = 'Approved';
                item.modifiedBy = Utils.getUser();
                item.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();

                var seafarers_pending_Ref = DB.collection("seafarers_pending").doc(item.id);
                batch.update(seafarers_pending_Ref, item);
                
                let seafarer = Object.assign({}, item);
                seafarer.id = Utils.getUniqueID();
                seafarer.createdBy = Utils.getUser();
                seafarer.createdAt = Firebase.firestore.FieldValue.serverTimestamp();
                seafarer.modifiedBy = Utils.getUser();
                seafarer.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();

                const travelDocuments = await DB.collection("travelDocuments_pending").where('parentID', '==', item.id).get();
                const spouceAndChildren = await DB.collection("spouceAndChildren_pending").where('parentID', '==', item.id).get();
                const stcwDocuments = await DB.collection("stcwDocuments_pending").where('parentID', '==', item.id).get();
                const otherDocuments = await DB.collection("otherDocuments_pending").where('parentID', '==', item.id).get();
                const seaExperianceOther = await DB.collection("seaExperianceOther_pending").where('parentID', '==', item.id).get();
                const medicalDocumentsPJ = await DB.collection("medicalDocumentsPJ_pending").where('parentID', '==', item.id).get();
                
                
                var seafarers_Ref = DB.collection("seafarers").doc(seafarer.id);
                batch.set(seafarers_Ref, seafarer);

                for(const doc of travelDocuments.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("travelDocuments").doc(newID); 
                    batch.set(ref, newDoc);
                }
                for(const doc of spouceAndChildren.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("spouceAndChildren").doc(newID); 
                    batch.set(ref, newDoc);
                }
                for(const doc of stcwDocuments.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("stcwDocuments").doc(newID); 
                    batch.set(ref, newDoc);
                }
                for(const doc of otherDocuments.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("otherDocuments").doc(newID); 
                    batch.set(ref, newDoc);
                }
                for(const doc of seaExperianceOther.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("seaExperianceOther").doc(newID); 
                    batch.set(ref, newDoc);
                }
                for(const doc of medicalDocumentsPJ.docs){
                    let newDoc = Object.assign({}, doc.data())
                    newDoc.parentID = seafarer.id;
                    let newID = Utils.getUniqueID();
                    newDoc.id = newID;
                    let ref = DB.collection("medicalDocumentsPJ").doc(newID); 
                    batch.set(ref, newDoc);
                }


                batch.commit().then(() => {
                    _this.showMsg("Application approved successfully!");
                    _this.isLoading = false;
                    _this.fetchAll();
                }).catch((error) => { 
                    _this.showError("Failed to approve Application. Error: ", error.message)
                    _this.isLoading = false;
                });
            }
        },
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        generateCV(id){
            var route = '/cv1?id=' + id + '&applicant=Y'         
            this.$router.push(route);
        },
        generateCV2(id){
            var route = '/cv2?id=' + id         
            this.$router.push(route);
        },
        formatDateTime(input){
            return Utils.formatDateTime(input);
        },
        getColor (status) {
            if(status == 'Pending')
                return "blue";
            else if(status == 'Approved')
                return "green";
            else if(status == 'Rejected')
                return "red";
        },
    },
    computed: {        
        getTitile(){
            if(this.propTitle == '')
                return 'Online CV Applications'
            else    
                return this.propTitle;
        },
        isUserLoggedIn(){
            return this.$store.state.user? true:false;
        },
        isUserAdmin(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Admin'){
                    return true;
                }
            }
            return false;
        },
        
    }, 
    
}


</script>



<style lang="scss">

</style>
